module.exports = __webpack_public_path__ + "static/benefit-plaque-award-13e360bc5ca011e884c7baa26724c092.png";